var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.765 11.772a.9.9 0 0 1 0 1.79l-.092.005h-.006a.901.901 0 0 1 0-1.8h.006zM13.333 11.917a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5zM2.765 7.104a.9.9 0 0 1 0 1.792l-.092.004h-.006a.9.9 0 0 1 0-1.8h.006zM13.333 7.25a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5zM2.765 2.438a.901.901 0 0 1 0 1.79l-.092.005h-.006a.9.9 0 0 1 0-1.8h.006zM13.333 2.583a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5z"
  })));
};
export default Svg16;